// extracted by mini-css-extract-plugin
module.exports = {"scaleInput":"styles_scaleInput__2Oui1","wrapper":"styles_wrapper__122o2","removeIcon":"styles_removeIcon__2UKID"};